import { render, staticRenderFns } from "./calendarDetail.vue?vue&type=template&id=678f658d"
import script from "./calendarDetail.vue?vue&type=script&lang=js"
export * from "./calendarDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678f658d')) {
      api.createRecord('678f658d', component.options)
    } else {
      api.reload('678f658d', component.options)
    }
    module.hot.accept("./calendarDetail.vue?vue&type=template&id=678f658d", function () {
      api.rerender('678f658d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/cal/calendarDetail.vue"
export default component.exports